export const services = {
  "Branded/Enterprise": 118,
  "Specialist/Corporate Plus": 116,
  "Basic/Corporate": 115,
  "AI/Economy": 106,
};
